module.exports = __webpack_public_path__ + "static/media/17@1920w.96a5987d.jpg";